import { Toast } from '../../../components/Common/Toast';
import { HTTPStatusEnum } from '../../../interfaces/log.interface';
import { callAPI } from '../../../services/api.service';
import { RespondModel } from '../Respond';
import { AppDispatch } from '../../../store/store';
import { setRedirectURL } from '../../../store/userSlice';

export const saveRespondPreOrderData = async (data: RespondModel, dispatch: AppDispatch): Promise<void> => {
  try {
    const response = await callAPI(
      'api/pre-order/create',
      {
        firstName: data.firstName?.trim(),
        lastName: data.lastName?.trim(),
        classCode: data.classCode?.trim(),
        studentUsername: data.studentUsername?.trim(),
        email: data.email?.trim(),
        orderDecision: data.orderDecision,
        isGuardian: data.confirm,
        confirmShare: data.confirmShare,
      },
      'POST',
    );

    if (response?.status === HTTPStatusEnum.OK) {
      if (response?.redirectURl) {
        dispatch(setRedirectURL(response?.redirectURl));
      }
    } else {
      Toast(response?.message || 'Unexpected Error Occurred', response?.status !== HTTPStatusEnum.OK);
    }
  } catch (error) {
    Toast('Failed to save data', true);
  }
};
